import type { VisualizationType } from '@tempo-io/roadmap-dto';
import { useTranslation } from 'react-i18next';
import { LoopNoItemsState } from '@/components/common/empty-state/LoopNoItemsState';

export const VisualizationNoItemsState = ({
  visualizationType,
}: {
  visualizationType: VisualizationType;
}) => {
  const { t } = useTranslation();

  const description =
    visualizationType === 'swimlane'
      ? t(($) => $.views.swimlane.emptyStates.noItems.description)
      : visualizationType === 'timeline'
        ? t(($) => $.views.timeline.emptyStates.noItems.description)
        : visualizationType === 'table'
          ? t(($) => $.views.table.emptyStates.noItems.description)
          : visualizationType === 'nodeGraph'
            ? t(($) => $.views.nodeGraph.emptyStates.noItems.description)
            : undefined;

  return <LoopNoItemsState description={description} />;
};
